export default class GoogleMap {
  constructor($el, lat, lng, marker = null) {
    this.lat = lat;
    this.lng = lng;
    this.marker = marker;

    const self = this;

    return $(document).ready(() => {
      const map = self.new_map($el);
      return map;
    });
  }

  /*
   *  new_map
   *
   *  This function will render a Google Map onto the selected jQuery element
   *
   *  @type	function
   *  @date	8/11/2013
   *  @since	4.3.0
   *
   *  @param	$el (jQuery element)
   *  @return	n/a
   */
  new_map($el) {
    // var
    const $markers = $el.find('.marker');
    const self = this;

    // vars
    const args = {
      zoom: 12,
      center: new google.maps.LatLng(0, 0),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      scrollwheel: false,
    };

    // create map
    const map = new google.maps.Map($el[0], args);

    // add a markers reference
    map.markers = [];

    // add markers
    $markers.each(function () {
      self.add_marker($(this), map);
    });

    // center map
    self.center_map(map);

    // return
    return map;
  }

  /*
   *  add_marker
   *
   *  This function will add a marker to the selected Google Map
   *
   *  @type	function
   *  @date	8/11/2013
   *  @since	4.3.0
   *
   *  @param	$marker (jQuery element)
   *  @param	map (Google Map object)
   *  @return	n/a
   */
  add_marker($marker, map) {
    // var
    const latlng = new google.maps.LatLng(this.lat, this.lng);
    const icon = this.marker;

    // create marker
    const marker = new google.maps.Marker({
      position: latlng,
      map,
      icon,
    });

    // add to array
    map.markers.push(marker);

    // if marker contains HTML, add it to an infoWindow
    if ($marker.html()) {
      // create info window
      const infowindow = new google.maps.InfoWindow({
        content: $marker.html(),
      });

      // show info window when marker is clicked
      google.maps.event.addListener(marker, 'click', () => {
        infowindow.open(map, marker);
      });
    }
  }

  /*
   *  center_map
   *
   *  This function will center the map, showing all markers attached to this map
   *
   *  @type	function
   *  @date	8/11/2013
   *  @since	4.3.0
   *
   *  @param	map (Google Map object)
   *  @return	n/a
   */
  center_map(map) {
    // vars
    const bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each(map.markers, (i, marker) => {
      const latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

      bounds.extend(latlng);
    });

    // only 1 marker?
    if (map.markers.length == 1) {
      // set center of map
      map.setCenter(bounds.getCenter());
      map.setZoom(16);
    } else {
      // fit to bounds
      map.fitBounds(bounds);
    }

    google.maps.event.addDomListener(window, 'resize', () => {
      google.maps.event.trigger(map, 'resize');
      map.setCenter(bounds.getCenter());
    });
  }
}



// WEBPACK FOOTER //
// ./assets/js/components/GoogleMap.js